import { render, staticRenderFns } from "./ReportProblemForm.vue?vue&type=template&id=8aa0fb6a&scoped=true"
import script from "./ReportProblemForm.vue?vue&type=script&lang=js"
export * from "./ReportProblemForm.vue?vue&type=script&lang=js"
import style0 from "./ReportProblemForm.vue?vue&type=style&index=0&id=8aa0fb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa0fb6a",
  null
  
)

export default component.exports